module.exports = __webpack_public_path__ + "media/images/icon_ball-4ca2737044ac99a4ed6ee8124e07d7e9.svg";